module.exports = __webpack_public_path__ + "img/p2.d29acbcc.png";